
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { WorksiteManagement } from "@/components/gestion/WorksiteManagement";
import { AddWorksite } from "@/components/gestion/AddWorksite";
import { WorksiteDetails } from "@/components/gestion/WorksiteDetails";
import { EditWorksite } from "@/components/gestion/EditWorksite";
import { UserManagement } from "@/components/gestion/UserManagement";
import { AddUser } from "@/components/gestion/AddUser";
import { UserDetails } from "@/components/gestion/UserDetails";
import { AddAssignment } from "@/components/gestion/AddAssignment";
import { EditUser } from "@/components/gestion/EditUser";
import { InternalMessagesManager } from "@/components/admin/InternalMessagesManager";

const Gestion = () => {
  return (
    <Routes>
      <Route path="/" element={<WorksiteManagement />} />
      <Route path="/worksites" element={<WorksiteManagement />} />
      <Route path="/worksites/add" element={<AddWorksite />} />
      <Route path="/worksites/details/:id" element={<WorksiteDetails />} />
      <Route path="/worksites/edit/:id" element={<EditWorksite />} />
      <Route path="/users" element={<UserManagement />} />
      <Route path="/users/add" element={<AddUser />} />
      <Route path="/users/details/:id" element={<UserDetails />} />
      <Route path="/users/edit/:id" element={<EditUser />} />
      <Route path="/users/details/:id/add-assignment" element={<AddAssignment />} />
      <Route path="/messages" element={<InternalMessagesManager />} />
    </Routes>
  );
};

export default Gestion;
